import { array, mixed, number, object, string } from "yup";
import {
  CurrentSubscriptionFeatureResource,
  currentSubscriptionFeatureResourceSchema,
} from "./CurrentSubscriptionFeatureResource";
import {
  PriceMoneyResource,
  priceMoneyResourceSchema,
} from "./PriceMoneyResource";
import { BillingType, PriceIntervalUnit } from "./PriceResource";

export interface PlanAddonPriceResource {
  uuid: string;
  money: PriceMoneyResource;
  billingType: BillingType;
  intervalUnit: PriceIntervalUnit | null;
}

export interface PlanAddonAddonResource {
  id: number;
  name: string;
  features: CurrentSubscriptionFeatureResource[];
}

export interface PlanAddonResource {
  id: number;
  addon: PlanAddonAddonResource;
  limit: number;
  prices: PlanAddonPriceResource[];
}

const planAddonPriceResourceSchema = object({
  uuid: string().required(),
  money: priceMoneyResourceSchema.required(),
  billingType: mixed<BillingType>()
    .oneOf(Object.values(BillingType) as BillingType[])
    .required(),
  intervalUnit: mixed<PriceIntervalUnit>()
    .oneOf(Object.values(PriceIntervalUnit) as PriceIntervalUnit[])
    .nullable()
    .default(null),
});

const planAddonAddonResourceSchema = object({
  id: number().required(),
  name: string().required(),
  features: array(currentSubscriptionFeatureResourceSchema).required(),
});

export const planAddonResourceSchema = object({
  id: number().required(),
  addon: planAddonAddonResourceSchema.required(),
  limit: number().required(),
  prices: array(planAddonPriceResourceSchema).required(),
});
